const updatePaymentsErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updatePaymentsErrors;
